//TODO this needs clean up at some point
// V2 Production Configuration for workflow86.com
const ROOT_DOMAIN = import.meta.env.VITE_ROOT_DOMAIN || 'workflow86.com';
const APP_URL = import.meta.env.VITE_APP_URL || `https://app.${ROOT_DOMAIN}`;
const COGNITO_DOMAIN = import.meta.env.VITE_COGNITO_DOMAIN || 'authenticateme.app.workflow86.com';

const awsconfig = {
  USAGE_SERVICE_ADDRESS: '',
  REGION: import.meta.env.VITE_AWS_REGION || 'ap-southeast-2',
  USER_POOL_ID: import.meta.env.VITE_USER_POOL_ID || 'ap-southeast-2_4pkuaVYZY',
  APP_CLIENT_ID: import.meta.env.VITE_APP_CLIENT_ID || '7k5h7tnrnkdcg78d9ofpt1opij',
  DOMAIN: `.${ROOT_DOMAIN}`,
  ISS: '',
};

const aws_config = {
  Auth: {
    Cognito: {
      userPoolId: awsconfig.USER_POOL_ID,
      userPoolClientId: awsconfig.APP_CLIENT_ID,
      signUpVerificationMethod: 'code',
      loginWith: {
        oauth: {
          domain: COGNITO_DOMAIN,
          scopes: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [APP_URL],
          redirectSignOut: [APP_URL],
          responseType: 'code',
        },
        username: true,
        email: true,
        phone: true,
      },
    },
    region: awsconfig.REGION,
    authenticationFlowType: 'USER_PASSWORD_AUTH',
  },
  oauth: {
    domain: COGNITO_DOMAIN,
    scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    redirectSignIn: APP_URL,
    redirectSignOut: APP_URL,
    responseType: 'code',
  },
  gg_client_id: '541992205730-eaa8et59jir07ttls4vqgci5hpe5hdr5.apps.googleusercontent.com',
};

// Keeping additional properties for reference, but not including in the main config
const additionalConfig = {
  mandatorySignId: true,
  cookieStorage: {
    domain: window.location.host.includes('localhost') ? 'localhost' : awsconfig.DOMAIN,
    path: '/',
    expires: 1,
    secure: false,
  },
  aws_cognito_region: 'ap-southeast-2',
  aws_user_pools_id: 'ap-southeast-2_4pkuaVYZY',
  aws_user_pools_web_client_id: '7k5h7tnrnkdcg78d9ofpt1opij',
  gg_client_id: '541992205730-eaa8et59jir07ttls4vqgci5hpe5hdr5.apps.googleusercontent.com',
};

export default aws_config;
